"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ahooks = require("ahooks");
var _reactTransitionGroup = require("react-transition-group");
var _classnames = _interopRequireDefault(require("classnames"));
var _TransitionHeight = require("../TransitionHeight");
var _utils = require("../../utils");
var _components = require("../../components");
var _Prompt = _interopRequireDefault(require("./Prompt"));
var _Screen = _interopRequireDefault(require("./Screen"));
require("./DynamicHeightCubby.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
// @HACK: desktop and mobile require different container elements, but this means that children get
// remounted when switching between them. It's a very edge case situation, but a sneaky bug when
// it crops up. This quick fix uses a React Portal to keep children mounted across screen sizes.
//
// This results in 2 additional divs:
//
//    <div class="cubby-reparentable">
//      <div class="cubby-reparentable-host-el">{children}</div>
//    </div>
//
// Adapted from https://github.com/facebook/react/issues/13044#issuecomment-428815909
// @TODO: think about this more and figure out something better! >_< =P
// - Should implementations of Cubby content be required to handle being remounted?
// - Should we just always use TransitionHeight for desktop and mobile so no remounting occurs?
var Reparentable = function Reparentable(_ref) {
  var el = _ref.el;
  var ref = (0, _react.useRef)();
  (0, _ahooks.useMount)(function () {
    ref.current.appendChild(el);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "--tag-dynamic-height-cubby-reparentable relative h-full"
  });
};
var createHostEl = function createHostEl() {
  var el = document.createElement('div');
  el.className = '--tag-dynamic-height-cubby-reparentable-host-el relative h-full';
  return el;
};
var CubbyContent = function CubbyContent(_ref2) {
  var contentKey = _ref2.contentKey,
    height = _ref2.height,
    maxHeightStyles = _ref2.maxHeightStyles,
    children = _ref2.children,
    contentWrapperStyles = _ref2.contentWrapperStyles;
  var _useCssMedia = (0, _utils.useCssMedia)(),
    md = _useCssMedia.md;
  // Placeholder element for `children` to live in via a Portal so that they don't get remounted
  // when switching between desktop and mobile
  var childrenHostEl = (0, _react.useMemo)(createHostEl, []);
  var cubbyContentClassName = (0, _classnames.default)('cubby-content bg-white flex-initial md:h-full', contentWrapperStyles);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cubby-content-container', 'fixed right-0 bottom-0 w-full', 'pointer-events-none overflow-auto overscroll-contain', 'flex flex-col justify-end',
    // Make cubby wide enough on desktop to show 4 columns of time slots
    // + add extra 17px for the scroll bar because scroll bar takes up
    // container width in some browsers
    'md:w-[calc(88px*4+24px*5+17px)]', maxHeightStyles || 'h-full')
  }, /*#__PURE__*/_reactDom.default.createPortal(children, childrenHostEl), md && /*#__PURE__*/_react.default.createElement("div", {
    className: cubbyContentClassName
  }, /*#__PURE__*/_react.default.createElement(Reparentable, {
    el: childrenHostEl
  })), !md && /*#__PURE__*/_react.default.createElement(_TransitionHeight.TransitionHeight, {
    contentKey: contentKey,
    height: height,
    className: cubbyContentClassName
  }, /*#__PURE__*/_react.default.createElement(Reparentable, {
    el: childrenHostEl
  })));
};

/**
 * Component that handles content that may have dynamic height throughout its render cycle
 * and resizes itself accordingly with smooth CSS animations.
 * Probably too complex of a component to use if its content will not have a dynamic height;
 * it's better to implement your own Cubby with the desired behavior.
 */
var DynamicHeightCubby = function DynamicHeightCubby(_ref3) {
  var className = _ref3.className,
    style = _ref3.style,
    contentKey = _ref3.contentKey,
    height = _ref3.height,
    maxHeightStyles = _ref3.maxHeightStyles,
    visible = _ref3.visible,
    onClose = _ref3.onClose,
    onExited = _ref3.onExited,
    children = _ref3.children,
    contentWrapperStyles = _ref3.contentWrapperStyles;
  // @TODO: may want to think more about the appropriate DOM node to use here
  var portalParent = document.querySelector('#root');
  // It might not exist yet
  if (!portalParent) {
    return null;
  }
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: visible,
    timeout: 300,
    classNames: "cubby",
    onExited: onExited,
    appear: true
    // Flag that helps to discard internal state when cubby is closed
    // in cases where it is important to reset internal state
    ,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cubby', 'fixed top-0 bottom-0 left-0 right-0 z-10', className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_components.Overlay, {
    className: "cubby-overlay absolute top-0 bottom-0 left-0 right-0",
    onClick: onClose,
    visible: visible
  }), /*#__PURE__*/_react.default.createElement(CubbyContent, {
    contentKey: contentKey,
    height: height || 'auto',
    maxHeightStyles: maxHeightStyles,
    contentWrapperStyles: contentWrapperStyles
  }, children))), portalParent);
};
DynamicHeightCubby.propTypes = {
  className: _propTypes.default.string,
  /**
   * Required if DynamicHeightCubby content changes height without unmounting
   * so that transition between heights can be animated
   */
  contentKey: _propTypes.default.any.isRequired,
  /* Whether the cubby should extend to height: 100% or size to its contents */
  height: _propTypes.default.oneOf([_TransitionHeight.TransitionHeightMode.Auto, _TransitionHeight.TransitionHeightMode.Full]),
  /* Control the maximum height of the cubby if the desired max height is not 100% */
  maxHeightStyles: _propTypes.default.string,
  visible: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func,
  onExited: _propTypes.default.func,
  children: _propTypes.default.any.isRequired,
  contentWrapperStyles: _propTypes.default.string
};
DynamicHeightCubby.Prompt = _Prompt.default;
DynamicHeightCubby.Screen = _Screen.default;
var _default = DynamicHeightCubby;
exports.default = _default;